var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),(!_vm.session.NoSeats)?_c('Hall'):_c('SelectPlaceWithoutHall'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }